import TigerSharkRestSystem from './TigerSharkRestSystem';



class AbstractRestSystem extends TigerSharkRestSystem {

  async authenticate(parameterUserName,parameterPassword) {
    const jwtRequest =  {
      username: parameterUserName,
      password: parameterPassword,
    };
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/authenticate';    
    return this.apiPost(url,jwtRequest);
  }  



  async fetchAccessFeeEvent(accessFeeEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getAccessFeeEvent?accessFeeEventId='+accessFeeEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchAccessFeeEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getAccessFeeEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertAccessFeeEvent(accessFeeEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertAccessFeeEvent';    
    return this.apiPostWithAccessToken(url,accessToken,accessFeeEvent);
  }

  async updateAccessFeeEvent(accessFeeEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateAccessFeeEvent';    
    return this.apiPostWithAccessToken(url,accessToken,accessFeeEvent);
  }

  async deleteAccessFeeEvent(accessFeeEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteAccessFeeEvent';    
    return this.apiPostWithAccessToken(url,accessToken,accessFeeEvent);
  }

  async fetchActivationDevice(activationDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getActivationDevice?activationDeviceId='+activationDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchActivationDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getActivationDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertActivationDevice(activationDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertActivationDevice';    
    return this.apiPostWithAccessToken(url,accessToken,activationDevice);
  }

  async updateActivationDevice(activationDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateActivationDevice';    
    return this.apiPostWithAccessToken(url,accessToken,activationDevice);
  }

  async deleteActivationDevice(activationDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteActivationDevice';    
    return this.apiPostWithAccessToken(url,accessToken,activationDevice);
  }

  async fetchActiveOndemandPayment(ondemandPaymentId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getActiveOndemandPayment?ondemandPaymentId='+ondemandPaymentId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchActiveOndemandPaymentArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getActiveOndemandPaymentArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertActiveOndemandPayment(activeOndemandPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertActiveOndemandPayment';    
    return this.apiPostWithAccessToken(url,accessToken,activeOndemandPayment);
  }

  async updateActiveOndemandPayment(activeOndemandPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateActiveOndemandPayment';    
    return this.apiPostWithAccessToken(url,accessToken,activeOndemandPayment);
  }

  async deleteActiveOndemandPayment(activeOndemandPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteActiveOndemandPayment';    
    return this.apiPostWithAccessToken(url,accessToken,activeOndemandPayment);
  }

  async fetchActiveServiceOrderBill(serviceOrderBillId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getActiveServiceOrderBill?serviceOrderBillId='+serviceOrderBillId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchActiveServiceOrderBillArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getActiveServiceOrderBillArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertActiveServiceOrderBill(activeServiceOrderBill,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertActiveServiceOrderBill';    
    return this.apiPostWithAccessToken(url,accessToken,activeServiceOrderBill);
  }

  async updateActiveServiceOrderBill(activeServiceOrderBill,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateActiveServiceOrderBill';    
    return this.apiPostWithAccessToken(url,accessToken,activeServiceOrderBill);
  }

  async deleteActiveServiceOrderBill(activeServiceOrderBill,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteActiveServiceOrderBill';    
    return this.apiPostWithAccessToken(url,accessToken,activeServiceOrderBill);
  }

  async fetchAspDevice(aspDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getAspDevice?aspDeviceId='+aspDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchAspDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getAspDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertAspDevice(aspDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertAspDevice';    
    return this.apiPostWithAccessToken(url,accessToken,aspDevice);
  }

  async updateAspDevice(aspDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateAspDevice';    
    return this.apiPostWithAccessToken(url,accessToken,aspDevice);
  }

  async deleteAspDevice(aspDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteAspDevice';    
    return this.apiPostWithAccessToken(url,accessToken,aspDevice);
  }

  async fetchBauDevice(bauDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getBauDevice?bauDeviceId='+bauDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchBauDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getBauDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertBauDevice(bauDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertBauDevice';    
    return this.apiPostWithAccessToken(url,accessToken,bauDevice);
  }

  async updateBauDevice(bauDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateBauDevice';    
    return this.apiPostWithAccessToken(url,accessToken,bauDevice);
  }

  async deleteBauDevice(bauDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteBauDevice';    
    return this.apiPostWithAccessToken(url,accessToken,bauDevice);
  }

  async fetchBrandActivationEvent(brandActivationEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getBrandActivationEvent?brandActivationEventId='+brandActivationEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchBrandActivationEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getBrandActivationEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertBrandActivationEvent(brandActivationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertBrandActivationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,brandActivationEvent);
  }

  async updateBrandActivationEvent(brandActivationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateBrandActivationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,brandActivationEvent);
  }

  async deleteBrandActivationEvent(brandActivationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteBrandActivationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,brandActivationEvent);
  }

  async fetchCancellationEvent(cancellationEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCancellationEvent?cancellationEventId='+cancellationEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchCancellationEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCancellationEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertCancellationEvent(cancellationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertCancellationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,cancellationEvent);
  }

  async updateCancellationEvent(cancellationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateCancellationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,cancellationEvent);
  }

  async deleteCancellationEvent(cancellationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteCancellationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,cancellationEvent);
  }

  async fetchCheckinDeployment(checkinDeploymentId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinDeployment?checkinDeploymentId='+checkinDeploymentId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchCheckinDeploymentArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinDeploymentArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertCheckinDeployment(checkinDeployment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertCheckinDeployment';    
    return this.apiPostWithAccessToken(url,accessToken,checkinDeployment);
  }

  async updateCheckinDeployment(checkinDeployment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateCheckinDeployment';    
    return this.apiPostWithAccessToken(url,accessToken,checkinDeployment);
  }

  async deleteCheckinDeployment(checkinDeployment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteCheckinDeployment';    
    return this.apiPostWithAccessToken(url,accessToken,checkinDeployment);
  }

  async fetchCheckinProject(checkinProjectId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinProject?checkinProjectId='+checkinProjectId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchCheckinProjectArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinProjectArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertCheckinProject(checkinProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertCheckinProject';    
    return this.apiPostWithAccessToken(url,accessToken,checkinProject);
  }

  async updateCheckinProject(checkinProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateCheckinProject';    
    return this.apiPostWithAccessToken(url,accessToken,checkinProject);
  }

  async deleteCheckinProject(checkinProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteCheckinProject';    
    return this.apiPostWithAccessToken(url,accessToken,checkinProject);
  }

  async fetchCheckinUnit(checkUnitId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinUnit?checkUnitId='+checkUnitId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchCheckinUnitArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinUnitArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertCheckinUnit(checkinUnit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertCheckinUnit';    
    return this.apiPostWithAccessToken(url,accessToken,checkinUnit);
  }

  async updateCheckinUnit(checkinUnit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateCheckinUnit';    
    return this.apiPostWithAccessToken(url,accessToken,checkinUnit);
  }

  async deleteCheckinUnit(checkinUnit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteCheckinUnit';    
    return this.apiPostWithAccessToken(url,accessToken,checkinUnit);
  }

  async fetchCheckinZone(checkinZoneId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinZone?checkinZoneId='+checkinZoneId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchCheckinZoneArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCheckinZoneArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertCheckinZone(checkinZone,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertCheckinZone';    
    return this.apiPostWithAccessToken(url,accessToken,checkinZone);
  }

  async updateCheckinZone(checkinZone,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateCheckinZone';    
    return this.apiPostWithAccessToken(url,accessToken,checkinZone);
  }

  async deleteCheckinZone(checkinZone,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteCheckinZone';    
    return this.apiPostWithAccessToken(url,accessToken,checkinZone);
  }

  async fetchClearBalanceEvent(clearBalanceEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClearBalanceEvent?clearBalanceEventId='+clearBalanceEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchClearBalanceEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClearBalanceEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertClearBalanceEvent(clearBalanceEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertClearBalanceEvent';    
    return this.apiPostWithAccessToken(url,accessToken,clearBalanceEvent);
  }

  async updateClearBalanceEvent(clearBalanceEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateClearBalanceEvent';    
    return this.apiPostWithAccessToken(url,accessToken,clearBalanceEvent);
  }

  async deleteClearBalanceEvent(clearBalanceEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteClearBalanceEvent';    
    return this.apiPostWithAccessToken(url,accessToken,clearBalanceEvent);
  }

  async fetchClientAccount(clientAccountId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientAccount?clientAccountId='+clientAccountId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchClientAccountArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientAccountArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertClientAccount(clientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,clientAccount);
  }

  async updateClientAccount(clientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,clientAccount);
  }

  async deleteClientAccount(clientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,clientAccount);
  }

  async fetchClientAccountType(clientAccountTypeId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientAccountType?clientAccountTypeId='+clientAccountTypeId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchClientAccountTypeArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientAccountTypeArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertClientAccountType(clientAccountType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertClientAccountType';    
    return this.apiPostWithAccessToken(url,accessToken,clientAccountType);
  }

  async updateClientAccountType(clientAccountType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateClientAccountType';    
    return this.apiPostWithAccessToken(url,accessToken,clientAccountType);
  }

  async deleteClientAccountType(clientAccountType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteClientAccountType';    
    return this.apiPostWithAccessToken(url,accessToken,clientAccountType);
  }

  async fetchClientDeposit(clientDepositId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientDeposit?clientDepositId='+clientDepositId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchClientDepositArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientDepositArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertClientDeposit(clientDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertClientDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,clientDeposit);
  }

  async updateClientDeposit(clientDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateClientDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,clientDeposit);
  }

  async deleteClientDeposit(clientDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteClientDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,clientDeposit);
  }

  async fetchClientRatedResults(clientRatedResultsId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientRatedResults?clientRatedResultsId='+clientRatedResultsId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchClientRatedResultsArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientRatedResultsArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertClientRatedResults(clientRatedResults,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertClientRatedResults';    
    return this.apiPostWithAccessToken(url,accessToken,clientRatedResults);
  }

  async updateClientRatedResults(clientRatedResults,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateClientRatedResults';    
    return this.apiPostWithAccessToken(url,accessToken,clientRatedResults);
  }

  async deleteClientRatedResults(clientRatedResults,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteClientRatedResults';    
    return this.apiPostWithAccessToken(url,accessToken,clientRatedResults);
  }

  async fetchClientWithdrawal(clientWithdrawalId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientWithdrawal?clientWithdrawalId='+clientWithdrawalId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchClientWithdrawalArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getClientWithdrawalArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertClientWithdrawal(clientWithdrawal,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertClientWithdrawal';    
    return this.apiPostWithAccessToken(url,accessToken,clientWithdrawal);
  }

  async updateClientWithdrawal(clientWithdrawal,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateClientWithdrawal';    
    return this.apiPostWithAccessToken(url,accessToken,clientWithdrawal);
  }

  async deleteClientWithdrawal(clientWithdrawal,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteClientWithdrawal';    
    return this.apiPostWithAccessToken(url,accessToken,clientWithdrawal);
  }

  async fetchConference(conferenceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConference?conferenceId='+conferenceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConferenceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferenceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConference(conference,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConference';    
    return this.apiPostWithAccessToken(url,accessToken,conference);
  }

  async updateConference(conference,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConference';    
    return this.apiPostWithAccessToken(url,accessToken,conference);
  }

  async deleteConference(conference,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConference';    
    return this.apiPostWithAccessToken(url,accessToken,conference);
  }

  async fetchConferenceAction(conferenceActionId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferenceAction?conferenceActionId='+conferenceActionId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConferenceActionArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferenceActionArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConferenceAction(conferenceAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConferenceAction';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceAction);
  }

  async updateConferenceAction(conferenceAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConferenceAction';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceAction);
  }

  async deleteConferenceAction(conferenceAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConferenceAction';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceAction);
  }

  async fetchConferencePoll(conferenceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferencePoll?conferenceId='+conferenceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConferencePollArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferencePollArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConferencePoll(conferencePoll,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConferencePoll';    
    return this.apiPostWithAccessToken(url,accessToken,conferencePoll);
  }

  async updateConferencePoll(conferencePoll,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConferencePoll';    
    return this.apiPostWithAccessToken(url,accessToken,conferencePoll);
  }

  async deleteConferencePoll(conferencePoll,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConferencePoll';    
    return this.apiPostWithAccessToken(url,accessToken,conferencePoll);
  }

  async fetchConferencePollInquiry(conferencePollInquiryId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferencePollInquiry?conferencePollInquiryId='+conferencePollInquiryId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConferencePollInquiryArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferencePollInquiryArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConferencePollInquiry(conferencePollInquiry,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConferencePollInquiry';    
    return this.apiPostWithAccessToken(url,accessToken,conferencePollInquiry);
  }

  async updateConferencePollInquiry(conferencePollInquiry,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConferencePollInquiry';    
    return this.apiPostWithAccessToken(url,accessToken,conferencePollInquiry);
  }

  async deleteConferencePollInquiry(conferencePollInquiry,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConferencePollInquiry';    
    return this.apiPostWithAccessToken(url,accessToken,conferencePollInquiry);
  }

  async fetchConferenceSpeakerQuestion(conferenceSpeakerQuestionId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferenceSpeakerQuestion?conferenceSpeakerQuestionId='+conferenceSpeakerQuestionId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConferenceSpeakerQuestionArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferenceSpeakerQuestionArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConferenceSpeakerQuestion(conferenceSpeakerQuestion,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConferenceSpeakerQuestion';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceSpeakerQuestion);
  }

  async updateConferenceSpeakerQuestion(conferenceSpeakerQuestion,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConferenceSpeakerQuestion';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceSpeakerQuestion);
  }

  async deleteConferenceSpeakerQuestion(conferenceSpeakerQuestion,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConferenceSpeakerQuestion';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceSpeakerQuestion);
  }

  async fetchConferenceTicket(conferenceTicketId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferenceTicket?conferenceTicketId='+conferenceTicketId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConferenceTicketArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConferenceTicketArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConferenceTicket(conferenceTicket,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConferenceTicket';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceTicket);
  }

  async updateConferenceTicket(conferenceTicket,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConferenceTicket';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceTicket);
  }

  async deleteConferenceTicket(conferenceTicket,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConferenceTicket';    
    return this.apiPostWithAccessToken(url,accessToken,conferenceTicket);
  }

  async fetchContactShareEvent(contactShareEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getContactShareEvent?contactShareEventId='+contactShareEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchContactShareEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getContactShareEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertContactShareEvent(contactShareEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertContactShareEvent';    
    return this.apiPostWithAccessToken(url,accessToken,contactShareEvent);
  }

  async updateContactShareEvent(contactShareEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateContactShareEvent';    
    return this.apiPostWithAccessToken(url,accessToken,contactShareEvent);
  }

  async deleteContactShareEvent(contactShareEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteContactShareEvent';    
    return this.apiPostWithAccessToken(url,accessToken,contactShareEvent);
  }

  async fetchConvention(conventionId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConvention?conventionId='+conventionId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConventionArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConventionArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConvention(convention,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConvention';    
    return this.apiPostWithAccessToken(url,accessToken,convention);
  }

  async updateConvention(convention,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConvention';    
    return this.apiPostWithAccessToken(url,accessToken,convention);
  }

  async deleteConvention(convention,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConvention';    
    return this.apiPostWithAccessToken(url,accessToken,convention);
  }

  async fetchConventionAction(conventionActionId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConventionAction?conventionActionId='+conventionActionId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConventionActionArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConventionActionArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConventionAction(conventionAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConventionAction';    
    return this.apiPostWithAccessToken(url,accessToken,conventionAction);
  }

  async updateConventionAction(conventionAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConventionAction';    
    return this.apiPostWithAccessToken(url,accessToken,conventionAction);
  }

  async deleteConventionAction(conventionAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConventionAction';    
    return this.apiPostWithAccessToken(url,accessToken,conventionAction);
  }

  async fetchConventionGuest(conventionGuestId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConventionGuest?conventionGuestId='+conventionGuestId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchConventionGuestArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getConventionGuestArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertConventionGuest(conventionGuest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertConventionGuest';    
    return this.apiPostWithAccessToken(url,accessToken,conventionGuest);
  }

  async updateConventionGuest(conventionGuest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateConventionGuest';    
    return this.apiPostWithAccessToken(url,accessToken,conventionGuest);
  }

  async deleteConventionGuest(conventionGuest,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteConventionGuest';    
    return this.apiPostWithAccessToken(url,accessToken,conventionGuest);
  }

  async fetchCsuDevice(csuDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCsuDevice?csuDeviceId='+csuDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchCsuDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getCsuDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertCsuDevice(csuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertCsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,csuDevice);
  }

  async updateCsuDevice(csuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateCsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,csuDevice);
  }

  async deleteCsuDevice(csuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteCsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,csuDevice);
  }

  async fetchDeploymentIncomeOverview(incomeOverviewId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getDeploymentIncomeOverview?incomeOverviewId='+incomeOverviewId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchDeploymentIncomeOverviewArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getDeploymentIncomeOverviewArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertDeploymentIncomeOverview(deploymentIncomeOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertDeploymentIncomeOverview';    
    return this.apiPostWithAccessToken(url,accessToken,deploymentIncomeOverview);
  }

  async updateDeploymentIncomeOverview(deploymentIncomeOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateDeploymentIncomeOverview';    
    return this.apiPostWithAccessToken(url,accessToken,deploymentIncomeOverview);
  }

  async deleteDeploymentIncomeOverview(deploymentIncomeOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteDeploymentIncomeOverview';    
    return this.apiPostWithAccessToken(url,accessToken,deploymentIncomeOverview);
  }

  async fetchDepositDevice(depositDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getDepositDevice?depositDeviceId='+depositDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchDepositDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getDepositDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertDepositDevice(depositDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertDepositDevice';    
    return this.apiPostWithAccessToken(url,accessToken,depositDevice);
  }

  async updateDepositDevice(depositDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateDepositDevice';    
    return this.apiPostWithAccessToken(url,accessToken,depositDevice);
  }

  async deleteDepositDevice(depositDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteDepositDevice';    
    return this.apiPostWithAccessToken(url,accessToken,depositDevice);
  }

  async fetchDepositEvent(depositEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getDepositEvent?depositEventId='+depositEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchDepositEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getDepositEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertDepositEvent(depositEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertDepositEvent';    
    return this.apiPostWithAccessToken(url,accessToken,depositEvent);
  }

  async updateDepositEvent(depositEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateDepositEvent';    
    return this.apiPostWithAccessToken(url,accessToken,depositEvent);
  }

  async deleteDepositEvent(depositEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteDepositEvent';    
    return this.apiPostWithAccessToken(url,accessToken,depositEvent);
  }

  async fetchEcosystem(ecosystemId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEcosystem?ecosystemId='+ecosystemId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchEcosystemArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEcosystemArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertEcosystem(ecosystem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertEcosystem';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystem);
  }

  async updateEcosystem(ecosystem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateEcosystem';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystem);
  }

  async deleteEcosystem(ecosystem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteEcosystem';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystem);
  }

  async fetchEcosystemDevice(ecosystemDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEcosystemDevice?ecosystemDeviceId='+ecosystemDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchEcosystemDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEcosystemDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertEcosystemDevice(ecosystemDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertEcosystemDevice';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystemDevice);
  }

  async updateEcosystemDevice(ecosystemDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateEcosystemDevice';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystemDevice);
  }

  async deleteEcosystemDevice(ecosystemDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteEcosystemDevice';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystemDevice);
  }

  async fetchEcosystemProject(ecosystemProjectId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEcosystemProject?ecosystemProjectId='+ecosystemProjectId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchEcosystemProjectArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEcosystemProjectArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertEcosystemProject(ecosystemProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertEcosystemProject';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystemProject);
  }

  async updateEcosystemProject(ecosystemProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateEcosystemProject';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystemProject);
  }

  async deleteEcosystemProject(ecosystemProject,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteEcosystemProject';    
    return this.apiPostWithAccessToken(url,accessToken,ecosystemProject);
  }

  async fetchEnrolledClientAccount(enrolledClientAccountId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEnrolledClientAccount?enrolledClientAccountId='+enrolledClientAccountId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchEnrolledClientAccountArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getEnrolledClientAccountArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertEnrolledClientAccount(enrolledClientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertEnrolledClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,enrolledClientAccount);
  }

  async updateEnrolledClientAccount(enrolledClientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateEnrolledClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,enrolledClientAccount);
  }

  async deleteEnrolledClientAccount(enrolledClientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteEnrolledClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,enrolledClientAccount);
  }

  async fetchExpositor(expositorId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositor?expositorId='+expositorId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchExpositorArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositorArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertExpositor(expositor,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertExpositor';    
    return this.apiPostWithAccessToken(url,accessToken,expositor);
  }

  async updateExpositor(expositor,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateExpositor';    
    return this.apiPostWithAccessToken(url,accessToken,expositor);
  }

  async deleteExpositor(expositor,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteExpositor';    
    return this.apiPostWithAccessToken(url,accessToken,expositor);
  }

  async fetchExpositorAccount(expositorAccountId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositorAccount?expositorAccountId='+expositorAccountId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchExpositorAccountArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositorAccountArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertExpositorAccount(expositorAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertExpositorAccount';    
    return this.apiPostWithAccessToken(url,accessToken,expositorAccount);
  }

  async updateExpositorAccount(expositorAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateExpositorAccount';    
    return this.apiPostWithAccessToken(url,accessToken,expositorAccount);
  }

  async deleteExpositorAccount(expositorAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteExpositorAccount';    
    return this.apiPostWithAccessToken(url,accessToken,expositorAccount);
  }

  async fetchExpositorAction(expositorActionId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositorAction?expositorActionId='+expositorActionId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchExpositorActionArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositorActionArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertExpositorAction(expositorAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertExpositorAction';    
    return this.apiPostWithAccessToken(url,accessToken,expositorAction);
  }

  async updateExpositorAction(expositorAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateExpositorAction';    
    return this.apiPostWithAccessToken(url,accessToken,expositorAction);
  }

  async deleteExpositorAction(expositorAction,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteExpositorAction';    
    return this.apiPostWithAccessToken(url,accessToken,expositorAction);
  }

  async fetchExpositorContent(expositorContentId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositorContent?expositorContentId='+expositorContentId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchExpositorContentArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getExpositorContentArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertExpositorContent(expositorContent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertExpositorContent';    
    return this.apiPostWithAccessToken(url,accessToken,expositorContent);
  }

  async updateExpositorContent(expositorContent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateExpositorContent';    
    return this.apiPostWithAccessToken(url,accessToken,expositorContent);
  }

  async deleteExpositorContent(expositorContent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteExpositorContent';    
    return this.apiPostWithAccessToken(url,accessToken,expositorContent);
  }

  async fetchGatewayDevice(gatewayDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGatewayDevice?gatewayDeviceId='+gatewayDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGatewayDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGatewayDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGatewayDevice(gatewayDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGatewayDevice';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayDevice);
  }

  async updateGatewayDevice(gatewayDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGatewayDevice';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayDevice);
  }

  async deleteGatewayDevice(gatewayDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGatewayDevice';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayDevice);
  }

  async fetchGatewayEvent(gatewayEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGatewayEvent?gatewayEventId='+gatewayEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGatewayEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGatewayEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGatewayEvent(gatewayEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGatewayEvent';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayEvent);
  }

  async updateGatewayEvent(gatewayEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGatewayEvent';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayEvent);
  }

  async deleteGatewayEvent(gatewayEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGatewayEvent';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayEvent);
  }

  async fetchGatewayPassage(gatewayPassageId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGatewayPassage?gatewayPassageId='+gatewayPassageId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGatewayPassageArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGatewayPassageArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGatewayPassage(gatewayPassage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGatewayPassage';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayPassage);
  }

  async updateGatewayPassage(gatewayPassage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGatewayPassage';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayPassage);
  }

  async deleteGatewayPassage(gatewayPassage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGatewayPassage';    
    return this.apiPostWithAccessToken(url,accessToken,gatewayPassage);
  }

  async fetchGreetingsDevice(greetingsDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGreetingsDevice?greetingsDeviceId='+greetingsDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGreetingsDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGreetingsDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGreetingsDevice(greetingsDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGreetingsDevice';    
    return this.apiPostWithAccessToken(url,accessToken,greetingsDevice);
  }

  async updateGreetingsDevice(greetingsDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGreetingsDevice';    
    return this.apiPostWithAccessToken(url,accessToken,greetingsDevice);
  }

  async deleteGreetingsDevice(greetingsDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGreetingsDevice';    
    return this.apiPostWithAccessToken(url,accessToken,greetingsDevice);
  }

  async fetchGreetingsMessage(greetingsMessageId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGreetingsMessage?greetingsMessageId='+greetingsMessageId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGreetingsMessageArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGreetingsMessageArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGreetingsMessage(greetingsMessage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGreetingsMessage';    
    return this.apiPostWithAccessToken(url,accessToken,greetingsMessage);
  }

  async updateGreetingsMessage(greetingsMessage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGreetingsMessage';    
    return this.apiPostWithAccessToken(url,accessToken,greetingsMessage);
  }

  async deleteGreetingsMessage(greetingsMessage,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGreetingsMessage';    
    return this.apiPostWithAccessToken(url,accessToken,greetingsMessage);
  }

  async fetchGroupedPayment(groupedPaymentId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPayment?groupedPaymentId='+groupedPaymentId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGroupedPaymentArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGroupedPayment(groupedPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGroupedPayment';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPayment);
  }

  async updateGroupedPayment(groupedPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGroupedPayment';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPayment);
  }

  async deleteGroupedPayment(groupedPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGroupedPayment';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPayment);
  }

  async fetchGroupedPaymentDoneEvent(groupedPaymentDoneEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentDoneEvent?groupedPaymentDoneEventId='+groupedPaymentDoneEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGroupedPaymentDoneEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentDoneEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGroupedPaymentDoneEvent(groupedPaymentDoneEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGroupedPaymentDoneEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentDoneEvent);
  }

  async updateGroupedPaymentDoneEvent(groupedPaymentDoneEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGroupedPaymentDoneEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentDoneEvent);
  }

  async deleteGroupedPaymentDoneEvent(groupedPaymentDoneEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGroupedPaymentDoneEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentDoneEvent);
  }

  async fetchGroupedPaymentEvent(groupedPaymentEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentEvent?groupedPaymentEventId='+groupedPaymentEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGroupedPaymentEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGroupedPaymentEvent(groupedPaymentEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGroupedPaymentEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentEvent);
  }

  async updateGroupedPaymentEvent(groupedPaymentEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGroupedPaymentEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentEvent);
  }

  async deleteGroupedPaymentEvent(groupedPaymentEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGroupedPaymentEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentEvent);
  }

  async fetchGroupedPaymentInitEvent(groupedPaymentInitEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentInitEvent?groupedPaymentInitEventId='+groupedPaymentInitEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGroupedPaymentInitEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentInitEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGroupedPaymentInitEvent(groupedPaymentInitEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGroupedPaymentInitEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentInitEvent);
  }

  async updateGroupedPaymentInitEvent(groupedPaymentInitEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGroupedPaymentInitEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentInitEvent);
  }

  async deleteGroupedPaymentInitEvent(groupedPaymentInitEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGroupedPaymentInitEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentInitEvent);
  }

  async fetchGroupedPaymentKillEvent(groupedPaymentKillEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentKillEvent?groupedPaymentKillEventId='+groupedPaymentKillEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGroupedPaymentKillEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentKillEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGroupedPaymentKillEvent(groupedPaymentKillEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGroupedPaymentKillEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentKillEvent);
  }

  async updateGroupedPaymentKillEvent(groupedPaymentKillEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGroupedPaymentKillEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentKillEvent);
  }

  async deleteGroupedPaymentKillEvent(groupedPaymentKillEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGroupedPaymentKillEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentKillEvent);
  }

  async fetchGroupedPaymentUndoEvent(groupedPaymentUndoEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentUndoEvent?groupedPaymentUndoEventId='+groupedPaymentUndoEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchGroupedPaymentUndoEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getGroupedPaymentUndoEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertGroupedPaymentUndoEvent(groupedPaymentUndoEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertGroupedPaymentUndoEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentUndoEvent);
  }

  async updateGroupedPaymentUndoEvent(groupedPaymentUndoEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateGroupedPaymentUndoEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentUndoEvent);
  }

  async deleteGroupedPaymentUndoEvent(groupedPaymentUndoEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteGroupedPaymentUndoEvent';    
    return this.apiPostWithAccessToken(url,accessToken,groupedPaymentUndoEvent);
  }

  async fetchInjectedClientAccount(clientAccountId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getInjectedClientAccount?clientAccountId='+clientAccountId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchInjectedClientAccountArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getInjectedClientAccountArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertInjectedClientAccount(injectedClientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertInjectedClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,injectedClientAccount);
  }

  async updateInjectedClientAccount(injectedClientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateInjectedClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,injectedClientAccount);
  }

  async deleteInjectedClientAccount(injectedClientAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteInjectedClientAccount';    
    return this.apiPostWithAccessToken(url,accessToken,injectedClientAccount);
  }

  async fetchLinkedAccount(linkedAccountId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getLinkedAccount?linkedAccountId='+linkedAccountId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchLinkedAccountArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getLinkedAccountArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertLinkedAccount(linkedAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertLinkedAccount';    
    return this.apiPostWithAccessToken(url,accessToken,linkedAccount);
  }

  async updateLinkedAccount(linkedAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateLinkedAccount';    
    return this.apiPostWithAccessToken(url,accessToken,linkedAccount);
  }

  async deleteLinkedAccount(linkedAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteLinkedAccount';    
    return this.apiPostWithAccessToken(url,accessToken,linkedAccount);
  }

  async fetchLiquidationEvent(liquidationEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getLiquidationEvent?liquidationEventId='+liquidationEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchLiquidationEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getLiquidationEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertLiquidationEvent(liquidationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertLiquidationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,liquidationEvent);
  }

  async updateLiquidationEvent(liquidationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateLiquidationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,liquidationEvent);
  }

  async deleteLiquidationEvent(liquidationEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteLiquidationEvent';    
    return this.apiPostWithAccessToken(url,accessToken,liquidationEvent);
  }

  async fetchMerchantAccount(merchantAccountId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantAccount?merchantAccountId='+merchantAccountId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantAccountArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantAccountArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantAccount(merchantAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantAccount';    
    return this.apiPostWithAccessToken(url,accessToken,merchantAccount);
  }

  async updateMerchantAccount(merchantAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantAccount';    
    return this.apiPostWithAccessToken(url,accessToken,merchantAccount);
  }

  async deleteMerchantAccount(merchantAccount,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantAccount';    
    return this.apiPostWithAccessToken(url,accessToken,merchantAccount);
  }

  async fetchMerchantAccountOverview(merchantAccountOverviewId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantAccountOverview?merchantAccountOverviewId='+merchantAccountOverviewId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantAccountOverviewArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantAccountOverviewArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantAccountOverview(merchantAccountOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantAccountOverview';    
    return this.apiPostWithAccessToken(url,accessToken,merchantAccountOverview);
  }

  async updateMerchantAccountOverview(merchantAccountOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantAccountOverview';    
    return this.apiPostWithAccessToken(url,accessToken,merchantAccountOverview);
  }

  async deleteMerchantAccountOverview(merchantAccountOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantAccountOverview';    
    return this.apiPostWithAccessToken(url,accessToken,merchantAccountOverview);
  }

  async fetchMerchantBrandActivation(merchantBrandActivationId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantBrandActivation?merchantBrandActivationId='+merchantBrandActivationId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantBrandActivationArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantBrandActivationArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantBrandActivation(merchantBrandActivation,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantBrandActivation';    
    return this.apiPostWithAccessToken(url,accessToken,merchantBrandActivation);
  }

  async updateMerchantBrandActivation(merchantBrandActivation,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantBrandActivation';    
    return this.apiPostWithAccessToken(url,accessToken,merchantBrandActivation);
  }

  async deleteMerchantBrandActivation(merchantBrandActivation,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantBrandActivation';    
    return this.apiPostWithAccessToken(url,accessToken,merchantBrandActivation);
  }

  async fetchMerchantDeposit(merchantDepositId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantDeposit?merchantDepositId='+merchantDepositId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantDepositArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantDepositArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantDeposit(merchantDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,merchantDeposit);
  }

  async updateMerchantDeposit(merchantDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,merchantDeposit);
  }

  async deleteMerchantDeposit(merchantDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,merchantDeposit);
  }

  async fetchMerchantIngredient(merchantIngredientId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantIngredient?merchantIngredientId='+merchantIngredientId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantIngredientArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantIngredientArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantIngredient(merchantIngredient,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantIngredient';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredient);
  }

  async updateMerchantIngredient(merchantIngredient,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantIngredient';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredient);
  }

  async deleteMerchantIngredient(merchantIngredient,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantIngredient';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredient);
  }

  async fetchMerchantIngredientEvent(merchantIngredientEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantIngredientEvent?merchantIngredientEventId='+merchantIngredientEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantIngredientEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantIngredientEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantIngredientEvent(merchantIngredientEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantIngredientEvent';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredientEvent);
  }

  async updateMerchantIngredientEvent(merchantIngredientEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantIngredientEvent';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredientEvent);
  }

  async deleteMerchantIngredientEvent(merchantIngredientEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantIngredientEvent';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredientEvent);
  }

  async fetchMerchantIngredientInventory(merchantInventoryId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantIngredientInventory?merchantInventoryId='+merchantInventoryId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantIngredientInventoryArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantIngredientInventoryArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantIngredientInventory(merchantIngredientInventory,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantIngredientInventory';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredientInventory);
  }

  async updateMerchantIngredientInventory(merchantIngredientInventory,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantIngredientInventory';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredientInventory);
  }

  async deleteMerchantIngredientInventory(merchantIngredientInventory,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantIngredientInventory';    
    return this.apiPostWithAccessToken(url,accessToken,merchantIngredientInventory);
  }

  async fetchMerchantPrivilege(merchantPrivilegeId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantPrivilege?merchantPrivilegeId='+merchantPrivilegeId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantPrivilegeArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantPrivilegeArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantPrivilege(merchantPrivilege,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantPrivilege';    
    return this.apiPostWithAccessToken(url,accessToken,merchantPrivilege);
  }

  async updateMerchantPrivilege(merchantPrivilege,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantPrivilege';    
    return this.apiPostWithAccessToken(url,accessToken,merchantPrivilege);
  }

  async deleteMerchantPrivilege(merchantPrivilege,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantPrivilege';    
    return this.apiPostWithAccessToken(url,accessToken,merchantPrivilege);
  }

  async fetchMerchantPrivilegeGroup(merchantPrivilegeGroupId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantPrivilegeGroup?merchantPrivilegeGroupId='+merchantPrivilegeGroupId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantPrivilegeGroupArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantPrivilegeGroupArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantPrivilegeGroup(merchantPrivilegeGroup,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantPrivilegeGroup';    
    return this.apiPostWithAccessToken(url,accessToken,merchantPrivilegeGroup);
  }

  async updateMerchantPrivilegeGroup(merchantPrivilegeGroup,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantPrivilegeGroup';    
    return this.apiPostWithAccessToken(url,accessToken,merchantPrivilegeGroup);
  }

  async deleteMerchantPrivilegeGroup(merchantPrivilegeGroup,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantPrivilegeGroup';    
    return this.apiPostWithAccessToken(url,accessToken,merchantPrivilegeGroup);
  }

  async fetchMerchantProduct(merchantProductId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantProduct?merchantProductId='+merchantProductId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantProductArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantProductArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantProduct(merchantProduct,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantProduct';    
    return this.apiPostWithAccessToken(url,accessToken,merchantProduct);
  }

  async updateMerchantProduct(merchantProduct,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantProduct';    
    return this.apiPostWithAccessToken(url,accessToken,merchantProduct);
  }

  async deleteMerchantProduct(merchantProduct,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantProduct';    
    return this.apiPostWithAccessToken(url,accessToken,merchantProduct);
  }

  async fetchMerchantProductOverview(merchantProductOverviewId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantProductOverview?merchantProductOverviewId='+merchantProductOverviewId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantProductOverviewArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantProductOverviewArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantProductOverview(merchantProductOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantProductOverview';    
    return this.apiPostWithAccessToken(url,accessToken,merchantProductOverview);
  }

  async updateMerchantProductOverview(merchantProductOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantProductOverview';    
    return this.apiPostWithAccessToken(url,accessToken,merchantProductOverview);
  }

  async deleteMerchantProductOverview(merchantProductOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantProductOverview';    
    return this.apiPostWithAccessToken(url,accessToken,merchantProductOverview);
  }

  async fetchMerchantRefund(merchantRefundId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantRefund?merchantRefundId='+merchantRefundId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchMerchantRefundArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getMerchantRefundArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertMerchantRefund(merchantRefund,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertMerchantRefund';    
    return this.apiPostWithAccessToken(url,accessToken,merchantRefund);
  }

  async updateMerchantRefund(merchantRefund,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateMerchantRefund';    
    return this.apiPostWithAccessToken(url,accessToken,merchantRefund);
  }

  async deleteMerchantRefund(merchantRefund,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteMerchantRefund';    
    return this.apiPostWithAccessToken(url,accessToken,merchantRefund);
  }

  async fetchOndemandPayment(ondemandPaymentId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getOndemandPayment?ondemandPaymentId='+ondemandPaymentId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchOndemandPaymentArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getOndemandPaymentArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertOndemandPayment(ondemandPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertOndemandPayment';    
    return this.apiPostWithAccessToken(url,accessToken,ondemandPayment);
  }

  async updateOndemandPayment(ondemandPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateOndemandPayment';    
    return this.apiPostWithAccessToken(url,accessToken,ondemandPayment);
  }

  async deleteOndemandPayment(ondemandPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteOndemandPayment';    
    return this.apiPostWithAccessToken(url,accessToken,ondemandPayment);
  }

  async fetchOsuDevice(osuDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getOsuDevice?osuDeviceId='+osuDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchOsuDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getOsuDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertOsuDevice(osuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertOsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,osuDevice);
  }

  async updateOsuDevice(osuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateOsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,osuDevice);
  }

  async deleteOsuDevice(osuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteOsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,osuDevice);
  }

  async fetchPendingGroupedPayment(groupedPaymentId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPendingGroupedPayment?groupedPaymentId='+groupedPaymentId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPendingGroupedPaymentArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPendingGroupedPaymentArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPendingGroupedPayment(pendingGroupedPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPendingGroupedPayment';    
    return this.apiPostWithAccessToken(url,accessToken,pendingGroupedPayment);
  }

  async updatePendingGroupedPayment(pendingGroupedPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePendingGroupedPayment';    
    return this.apiPostWithAccessToken(url,accessToken,pendingGroupedPayment);
  }

  async deletePendingGroupedPayment(pendingGroupedPayment,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePendingGroupedPayment';    
    return this.apiPostWithAccessToken(url,accessToken,pendingGroupedPayment);
  }

  async fetchPgpDevice(pgpDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPgpDevice?pgpDeviceId='+pgpDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPgpDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPgpDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPgpDevice(pgpDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPgpDevice';    
    return this.apiPostWithAccessToken(url,accessToken,pgpDevice);
  }

  async updatePgpDevice(pgpDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePgpDevice';    
    return this.apiPostWithAccessToken(url,accessToken,pgpDevice);
  }

  async deletePgpDevice(pgpDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePgpDevice';    
    return this.apiPostWithAccessToken(url,accessToken,pgpDevice);
  }

  async fetchPluDevice(pluDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPluDevice?pluDeviceId='+pluDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPluDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPluDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPluDevice(pluDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPluDevice';    
    return this.apiPostWithAccessToken(url,accessToken,pluDevice);
  }

  async updatePluDevice(pluDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePluDevice';    
    return this.apiPostWithAccessToken(url,accessToken,pluDevice);
  }

  async deletePluDevice(pluDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePluDevice';    
    return this.apiPostWithAccessToken(url,accessToken,pluDevice);
  }

  async fetchPosDevice(posDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPosDevice?posDeviceId='+posDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPosDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPosDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPosDevice(posDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPosDevice';    
    return this.apiPostWithAccessToken(url,accessToken,posDevice);
  }

  async updatePosDevice(posDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePosDevice';    
    return this.apiPostWithAccessToken(url,accessToken,posDevice);
  }

  async deletePosDevice(posDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePosDevice';    
    return this.apiPostWithAccessToken(url,accessToken,posDevice);
  }

  async fetchPostpaymentCloseEvent(postpaymentCloseEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPostpaymentCloseEvent?postpaymentCloseEventId='+postpaymentCloseEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPostpaymentCloseEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPostpaymentCloseEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPostpaymentCloseEvent(postpaymentCloseEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPostpaymentCloseEvent';    
    return this.apiPostWithAccessToken(url,accessToken,postpaymentCloseEvent);
  }

  async updatePostpaymentCloseEvent(postpaymentCloseEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePostpaymentCloseEvent';    
    return this.apiPostWithAccessToken(url,accessToken,postpaymentCloseEvent);
  }

  async deletePostpaymentCloseEvent(postpaymentCloseEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePostpaymentCloseEvent';    
    return this.apiPostWithAccessToken(url,accessToken,postpaymentCloseEvent);
  }

  async fetchPrivilegeGrantEvent(privilegeGrantEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPrivilegeGrantEvent?privilegeGrantEventId='+privilegeGrantEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPrivilegeGrantEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPrivilegeGrantEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPrivilegeGrantEvent(privilegeGrantEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPrivilegeGrantEvent';    
    return this.apiPostWithAccessToken(url,accessToken,privilegeGrantEvent);
  }

  async updatePrivilegeGrantEvent(privilegeGrantEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePrivilegeGrantEvent';    
    return this.apiPostWithAccessToken(url,accessToken,privilegeGrantEvent);
  }

  async deletePrivilegeGrantEvent(privilegeGrantEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePrivilegeGrantEvent';    
    return this.apiPostWithAccessToken(url,accessToken,privilegeGrantEvent);
  }

  async fetchPrivilegeRedeemEvent(privilegeRedeemEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPrivilegeRedeemEvent?privilegeRedeemEventId='+privilegeRedeemEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPrivilegeRedeemEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPrivilegeRedeemEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPrivilegeRedeemEvent(privilegeRedeemEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPrivilegeRedeemEvent';    
    return this.apiPostWithAccessToken(url,accessToken,privilegeRedeemEvent);
  }

  async updatePrivilegeRedeemEvent(privilegeRedeemEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePrivilegeRedeemEvent';    
    return this.apiPostWithAccessToken(url,accessToken,privilegeRedeemEvent);
  }

  async deletePrivilegeRedeemEvent(privilegeRedeemEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePrivilegeRedeemEvent';    
    return this.apiPostWithAccessToken(url,accessToken,privilegeRedeemEvent);
  }

  async fetchPrpDevice(prpDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPrpDevice?prpDeviceId='+prpDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchPrpDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getPrpDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertPrpDevice(prpDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertPrpDevice';    
    return this.apiPostWithAccessToken(url,accessToken,prpDevice);
  }

  async updatePrpDevice(prpDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updatePrpDevice';    
    return this.apiPostWithAccessToken(url,accessToken,prpDevice);
  }

  async deletePrpDevice(prpDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deletePrpDevice';    
    return this.apiPostWithAccessToken(url,accessToken,prpDevice);
  }

  async fetchRatedActivity(ratedActivityId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRatedActivity?ratedActivityId='+ratedActivityId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRatedActivityArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRatedActivityArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRatedActivity(ratedActivity,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRatedActivity';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivity);
  }

  async updateRatedActivity(ratedActivity,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRatedActivity';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivity);
  }

  async deleteRatedActivity(ratedActivity,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRatedActivity';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivity);
  }

  async fetchRatedActivityEvent(ratedActivityEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRatedActivityEvent?ratedActivityEventId='+ratedActivityEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRatedActivityEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRatedActivityEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRatedActivityEvent(ratedActivityEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRatedActivityEvent';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivityEvent);
  }

  async updateRatedActivityEvent(ratedActivityEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRatedActivityEvent';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivityEvent);
  }

  async deleteRatedActivityEvent(ratedActivityEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRatedActivityEvent';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivityEvent);
  }

  async fetchRatedActivityMatch(ratedActivityMatchId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRatedActivityMatch?ratedActivityMatchId='+ratedActivityMatchId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRatedActivityMatchArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRatedActivityMatchArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRatedActivityMatch(ratedActivityMatch,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRatedActivityMatch';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivityMatch);
  }

  async updateRatedActivityMatch(ratedActivityMatch,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRatedActivityMatch';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivityMatch);
  }

  async deleteRatedActivityMatch(ratedActivityMatch,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRatedActivityMatch';    
    return this.apiPostWithAccessToken(url,accessToken,ratedActivityMatch);
  }

  async fetchRauDevice(rauDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRauDevice?rauDeviceId='+rauDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRauDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRauDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRauDevice(rauDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRauDevice';    
    return this.apiPostWithAccessToken(url,accessToken,rauDevice);
  }

  async updateRauDevice(rauDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRauDevice';    
    return this.apiPostWithAccessToken(url,accessToken,rauDevice);
  }

  async deleteRauDevice(rauDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRauDevice';    
    return this.apiPostWithAccessToken(url,accessToken,rauDevice);
  }

  async fetchRefundEvent(refundEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRefundEvent?refundEventId='+refundEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRefundEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRefundEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRefundEvent(refundEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRefundEvent';    
    return this.apiPostWithAccessToken(url,accessToken,refundEvent);
  }

  async updateRefundEvent(refundEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRefundEvent';    
    return this.apiPostWithAccessToken(url,accessToken,refundEvent);
  }

  async deleteRefundEvent(refundEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRefundEvent';    
    return this.apiPostWithAccessToken(url,accessToken,refundEvent);
  }

  async fetchRegistryEvent(registryEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRegistryEvent?registryEventId='+registryEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRegistryEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRegistryEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRegistryEvent(registryEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRegistryEvent';    
    return this.apiPostWithAccessToken(url,accessToken,registryEvent);
  }

  async updateRegistryEvent(registryEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRegistryEvent';    
    return this.apiPostWithAccessToken(url,accessToken,registryEvent);
  }

  async deleteRegistryEvent(registryEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRegistryEvent';    
    return this.apiPostWithAccessToken(url,accessToken,registryEvent);
  }

  async fetchRemoteClearBalance(remoteClearBalanceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRemoteClearBalance?remoteClearBalanceId='+remoteClearBalanceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRemoteClearBalanceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRemoteClearBalanceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRemoteClearBalance(remoteClearBalance,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRemoteClearBalance';    
    return this.apiPostWithAccessToken(url,accessToken,remoteClearBalance);
  }

  async updateRemoteClearBalance(remoteClearBalance,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRemoteClearBalance';    
    return this.apiPostWithAccessToken(url,accessToken,remoteClearBalance);
  }

  async deleteRemoteClearBalance(remoteClearBalance,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRemoteClearBalance';    
    return this.apiPostWithAccessToken(url,accessToken,remoteClearBalance);
  }

  async fetchRemoteDeposit(remoteDepositId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRemoteDeposit?remoteDepositId='+remoteDepositId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRemoteDepositArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRemoteDepositArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRemoteDeposit(remoteDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRemoteDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,remoteDeposit);
  }

  async updateRemoteDeposit(remoteDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRemoteDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,remoteDeposit);
  }

  async deleteRemoteDeposit(remoteDeposit,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRemoteDeposit';    
    return this.apiPostWithAccessToken(url,accessToken,remoteDeposit);
  }

  async fetchRemoteTransfer(transferEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRemoteTransfer?transferEventId='+transferEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchRemoteTransferArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getRemoteTransferArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertRemoteTransfer(remoteTransfer,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertRemoteTransfer';    
    return this.apiPostWithAccessToken(url,accessToken,remoteTransfer);
  }

  async updateRemoteTransfer(remoteTransfer,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateRemoteTransfer';    
    return this.apiPostWithAccessToken(url,accessToken,remoteTransfer);
  }

  async deleteRemoteTransfer(remoteTransfer,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteRemoteTransfer';    
    return this.apiPostWithAccessToken(url,accessToken,remoteTransfer);
  }

  async fetchSaleEvent(saleEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSaleEvent?saleEventId='+saleEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSaleEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSaleEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSaleEvent(saleEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSaleEvent';    
    return this.apiPostWithAccessToken(url,accessToken,saleEvent);
  }

  async updateSaleEvent(saleEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSaleEvent';    
    return this.apiPostWithAccessToken(url,accessToken,saleEvent);
  }

  async deleteSaleEvent(saleEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSaleEvent';    
    return this.apiPostWithAccessToken(url,accessToken,saleEvent);
  }

  async fetchServiceOrderBill(serviceOrderBillId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBill?serviceOrderBillId='+serviceOrderBillId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceOrderBillArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBillArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceOrderBill(serviceOrderBill,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceOrderBill';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBill);
  }

  async updateServiceOrderBill(serviceOrderBill,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceOrderBill';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBill);
  }

  async deleteServiceOrderBill(serviceOrderBill,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceOrderBill';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBill);
  }

  async fetchServiceOrderBillDoneEvent(serviceOrderBillDoneId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBillDoneEvent?serviceOrderBillDoneId='+serviceOrderBillDoneId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceOrderBillDoneEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBillDoneEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceOrderBillDoneEvent(serviceOrderBillDoneEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceOrderBillDoneEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillDoneEvent);
  }

  async updateServiceOrderBillDoneEvent(serviceOrderBillDoneEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceOrderBillDoneEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillDoneEvent);
  }

  async deleteServiceOrderBillDoneEvent(serviceOrderBillDoneEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceOrderBillDoneEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillDoneEvent);
  }

  async fetchServiceOrderBillInitEvent(serviceOrderBillInitId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBillInitEvent?serviceOrderBillInitId='+serviceOrderBillInitId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceOrderBillInitEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBillInitEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceOrderBillInitEvent(serviceOrderBillInitEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceOrderBillInitEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillInitEvent);
  }

  async updateServiceOrderBillInitEvent(serviceOrderBillInitEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceOrderBillInitEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillInitEvent);
  }

  async deleteServiceOrderBillInitEvent(serviceOrderBillInitEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceOrderBillInitEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillInitEvent);
  }

  async fetchServiceOrderBillUndoEvent(serviceOrderBillUndoId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBillUndoEvent?serviceOrderBillUndoId='+serviceOrderBillUndoId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceOrderBillUndoEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderBillUndoEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceOrderBillUndoEvent(serviceOrderBillUndoEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceOrderBillUndoEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillUndoEvent);
  }

  async updateServiceOrderBillUndoEvent(serviceOrderBillUndoEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceOrderBillUndoEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillUndoEvent);
  }

  async deleteServiceOrderBillUndoEvent(serviceOrderBillUndoEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceOrderBillUndoEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderBillUndoEvent);
  }

  async fetchServiceOrderEvent(serviceOrderEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderEvent?serviceOrderEventId='+serviceOrderEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceOrderEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceOrderEvent(serviceOrderEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceOrderEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderEvent);
  }

  async updateServiceOrderEvent(serviceOrderEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceOrderEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderEvent);
  }

  async deleteServiceOrderEvent(serviceOrderEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceOrderEvent';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderEvent);
  }

  async fetchServiceOrderItem(serviceOrderItemId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderItem?serviceOrderItemId='+serviceOrderItemId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceOrderItemArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceOrderItemArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceOrderItem(serviceOrderItem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceOrderItem';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderItem);
  }

  async updateServiceOrderItem(serviceOrderItem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceOrderItem';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderItem);
  }

  async deleteServiceOrderItem(serviceOrderItem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceOrderItem';    
    return this.apiPostWithAccessToken(url,accessToken,serviceOrderItem);
  }

  async fetchServiceSequence(serviceSequenceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceSequence?serviceSequenceId='+serviceSequenceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceSequenceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceSequenceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceSequence(serviceSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceSequence';    
    return this.apiPostWithAccessToken(url,accessToken,serviceSequence);
  }

  async updateServiceSequence(serviceSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceSequence';    
    return this.apiPostWithAccessToken(url,accessToken,serviceSequence);
  }

  async deleteServiceSequence(serviceSequence,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceSequence';    
    return this.apiPostWithAccessToken(url,accessToken,serviceSequence);
  }

  async fetchServiceTable(serviceTableId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceTable?serviceTableId='+serviceTableId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchServiceTableArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getServiceTableArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertServiceTable(serviceTable,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertServiceTable';    
    return this.apiPostWithAccessToken(url,accessToken,serviceTable);
  }

  async updateServiceTable(serviceTable,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateServiceTable';    
    return this.apiPostWithAccessToken(url,accessToken,serviceTable);
  }

  async deleteServiceTable(serviceTable,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteServiceTable';    
    return this.apiPostWithAccessToken(url,accessToken,serviceTable);
  }

  async fetchSopDevice(sopDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSopDevice?sopDeviceId='+sopDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSopDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSopDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSopDevice(sopDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSopDevice';    
    return this.apiPostWithAccessToken(url,accessToken,sopDevice);
  }

  async updateSopDevice(sopDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSopDevice';    
    return this.apiPostWithAccessToken(url,accessToken,sopDevice);
  }

  async deleteSopDevice(sopDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSopDevice';    
    return this.apiPostWithAccessToken(url,accessToken,sopDevice);
  }

  async fetchSosDevice(sosDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSosDevice?sosDeviceId='+sosDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSosDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSosDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSosDevice(sosDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSosDevice';    
    return this.apiPostWithAccessToken(url,accessToken,sosDevice);
  }

  async updateSosDevice(sosDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSosDevice';    
    return this.apiPostWithAccessToken(url,accessToken,sosDevice);
  }

  async deleteSosDevice(sosDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSosDevice';    
    return this.apiPostWithAccessToken(url,accessToken,sosDevice);
  }

  async fetchSsuDevice(ssuDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSsuDevice?ssuDeviceId='+ssuDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSsuDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSsuDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSsuDevice(ssuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,ssuDevice);
  }

  async updateSsuDevice(ssuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,ssuDevice);
  }

  async deleteSsuDevice(ssuDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSsuDevice';    
    return this.apiPostWithAccessToken(url,accessToken,ssuDevice);
  }

  async fetchStaffUser(staffUserId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getStaffUser?staffUserId='+staffUserId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchStaffUserArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getStaffUserArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertStaffUser(staffUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertStaffUser';    
    return this.apiPostWithAccessToken(url,accessToken,staffUser);
  }

  async updateStaffUser(staffUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateStaffUser';    
    return this.apiPostWithAccessToken(url,accessToken,staffUser);
  }

  async deleteStaffUser(staffUser,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteStaffUser';    
    return this.apiPostWithAccessToken(url,accessToken,staffUser);
  }

  async fetchStaffUserOverview(staffUserOverviewId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getStaffUserOverview?staffUserOverviewId='+staffUserOverviewId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchStaffUserOverviewArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getStaffUserOverviewArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertStaffUserOverview(staffUserOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertStaffUserOverview';    
    return this.apiPostWithAccessToken(url,accessToken,staffUserOverview);
  }

  async updateStaffUserOverview(staffUserOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateStaffUserOverview';    
    return this.apiPostWithAccessToken(url,accessToken,staffUserOverview);
  }

  async deleteStaffUserOverview(staffUserOverview,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteStaffUserOverview';    
    return this.apiPostWithAccessToken(url,accessToken,staffUserOverview);
  }

  async fetchStaffUserType(staffUserTypeId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getStaffUserType?staffUserTypeId='+staffUserTypeId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchStaffUserTypeArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getStaffUserTypeArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertStaffUserType(staffUserType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertStaffUserType';    
    return this.apiPostWithAccessToken(url,accessToken,staffUserType);
  }

  async updateStaffUserType(staffUserType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateStaffUserType';    
    return this.apiPostWithAccessToken(url,accessToken,staffUserType);
  }

  async deleteStaffUserType(staffUserType,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteStaffUserType';    
    return this.apiPostWithAccessToken(url,accessToken,staffUserType);
  }

  async fetchSubstitutionEvent(substitutionEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSubstitutionEvent?substitutionEventId='+substitutionEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSubstitutionEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSubstitutionEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSubstitutionEvent(substitutionEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSubstitutionEvent';    
    return this.apiPostWithAccessToken(url,accessToken,substitutionEvent);
  }

  async updateSubstitutionEvent(substitutionEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSubstitutionEvent';    
    return this.apiPostWithAccessToken(url,accessToken,substitutionEvent);
  }

  async deleteSubstitutionEvent(substitutionEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSubstitutionEvent';    
    return this.apiPostWithAccessToken(url,accessToken,substitutionEvent);
  }

  async fetchSupervisorDevice(supervisorDeviceId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSupervisorDevice?supervisorDeviceId='+supervisorDeviceId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSupervisorDeviceArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSupervisorDeviceArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSupervisorDevice(supervisorDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSupervisorDevice';    
    return this.apiPostWithAccessToken(url,accessToken,supervisorDevice);
  }

  async updateSupervisorDevice(supervisorDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSupervisorDevice';    
    return this.apiPostWithAccessToken(url,accessToken,supervisorDevice);
  }

  async deleteSupervisorDevice(supervisorDevice,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSupervisorDevice';    
    return this.apiPostWithAccessToken(url,accessToken,supervisorDevice);
  }

  async fetchSupplyItem(supplyItemId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSupplyItem?supplyItemId='+supplyItemId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchSupplyItemArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getSupplyItemArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertSupplyItem(supplyItem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertSupplyItem';    
    return this.apiPostWithAccessToken(url,accessToken,supplyItem);
  }

  async updateSupplyItem(supplyItem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateSupplyItem';    
    return this.apiPostWithAccessToken(url,accessToken,supplyItem);
  }

  async deleteSupplyItem(supplyItem,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteSupplyItem';    
    return this.apiPostWithAccessToken(url,accessToken,supplyItem);
  }

  async fetchTagInventory(tagInventoryId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTagInventory?tagInventoryId='+tagInventoryId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchTagInventoryArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTagInventoryArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertTagInventory(tagInventory,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertTagInventory';    
    return this.apiPostWithAccessToken(url,accessToken,tagInventory);
  }

  async updateTagInventory(tagInventory,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateTagInventory';    
    return this.apiPostWithAccessToken(url,accessToken,tagInventory);
  }

  async deleteTagInventory(tagInventory,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteTagInventory';    
    return this.apiPostWithAccessToken(url,accessToken,tagInventory);
  }

  async fetchTimeFrame(timeFrameId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTimeFrame?timeFrameId='+timeFrameId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchTimeFrameArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTimeFrameArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertTimeFrame(timeFrame,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertTimeFrame';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrame);
  }

  async updateTimeFrame(timeFrame,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateTimeFrame';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrame);
  }

  async deleteTimeFrame(timeFrame,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteTimeFrame';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrame);
  }

  async fetchTimeFrameConfiguration(timeFrameConfigurationId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTimeFrameConfiguration?timeFrameConfigurationId='+timeFrameConfigurationId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchTimeFrameConfigurationArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTimeFrameConfigurationArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertTimeFrameConfiguration(timeFrameConfiguration,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertTimeFrameConfiguration';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrameConfiguration);
  }

  async updateTimeFrameConfiguration(timeFrameConfiguration,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateTimeFrameConfiguration';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrameConfiguration);
  }

  async deleteTimeFrameConfiguration(timeFrameConfiguration,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteTimeFrameConfiguration';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrameConfiguration);
  }

  async fetchTimeFrameTemplate(timeFrameTemplateId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTimeFrameTemplate?timeFrameTemplateId='+timeFrameTemplateId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchTimeFrameTemplateArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTimeFrameTemplateArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertTimeFrameTemplate(timeFrameTemplate,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertTimeFrameTemplate';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrameTemplate);
  }

  async updateTimeFrameTemplate(timeFrameTemplate,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateTimeFrameTemplate';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrameTemplate);
  }

  async deleteTimeFrameTemplate(timeFrameTemplate,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteTimeFrameTemplate';    
    return this.apiPostWithAccessToken(url,accessToken,timeFrameTemplate);
  }

  async fetchTipEvent(tipEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTipEvent?tipEventId='+tipEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchTipEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTipEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertTipEvent(tipEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertTipEvent';    
    return this.apiPostWithAccessToken(url,accessToken,tipEvent);
  }

  async updateTipEvent(tipEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateTipEvent';    
    return this.apiPostWithAccessToken(url,accessToken,tipEvent);
  }

  async deleteTipEvent(tipEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteTipEvent';    
    return this.apiPostWithAccessToken(url,accessToken,tipEvent);
  }

  async fetchTransferEvent(transferEventId,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTransferEvent?transferEventId='+transferEventId;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async fetchTransferEventArray(condition,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/getTransferEventArray?condition=' + condition;    
    return this.apiFetchWithAccessToken(url,accessToken);
  }  

  async insertTransferEvent(transferEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/insertTransferEvent';    
    return this.apiPostWithAccessToken(url,accessToken,transferEvent);
  }

  async updateTransferEvent(transferEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/updateTransferEvent';    
    return this.apiPostWithAccessToken(url,accessToken,transferEvent);
  }

  async deleteTransferEvent(transferEvent,accessToken) {
    const url = this.framework.getMemorySystem().getNexusUrl()+ '/persistenceManager/deleteTransferEvent';    
    return this.apiPostWithAccessToken(url,accessToken,transferEvent);
  }



}

export default AbstractRestSystem;